import { createApp } from 'vue'
import App from './App.vue'

import './index.css';  // Import de votre fichier CSS Tailwind généré

createApp(App).mount('#app')
